import React from "react";
import { Collapse, Form, Row, Col, Select, Input, Space, Button, DatePicker } from "antd";
// import { RootStateOrAny, useSelector } from "react-redux";
import moment from "moment";
import { FormFieldValue } from "../../lib/interfaces/FormFieldValue";
import { displayFormat } from "../../lib/utils/formatDate";
import { AnyObject } from "../../lib/interfaces";

const { Panel } = Collapse;
const { Option } = Select;

interface IProps {
  advancedSearchForm: any;
  initialStateFilters: AnyObject;
  // advancedSearchFormValues: FormFieldValue[] | undefined;
  dicCurrencies: AnyObject[];
  offerList: AnyObject[];
  setFilters: any;
  // dicRoutingOrdersStatuses: any[];
  // loadRoutingOrdersList: any;
}

// interface IProps {
//   handlePageableSearch: (values: FormFieldValue[]) => void;
//   setAccountListPage: (page: number) => void;
//   advancedSearchFormValues: FormFieldValue[];
//   setAdvancedSearchFormValues: React.Dispatch<React.SetStateAction<FormFieldValue[] | undefined>>;
//   setIsPageableSearch: React.Dispatch<React.SetStateAction<boolean>>;
//   isPageableSearch: boolean;
//   setSearchByNameFields: React.Dispatch<React.SetStateAction<FormFieldValue[] | undefined>>;
//   searchByNameForm: any;
//   advancedSearchForm: any;
// }

export function SearchFilterRoutingPlans({
  advancedSearchForm,
  // advancedSearchFormValues,
  dicCurrencies,
  offerList,
  initialStateFilters,
  setFilters,
}: // dicRoutingOrdersStatuses,
// loadRoutingOrdersList
IProps) {
  // const {
  //   handlePageableSearch,
  //   setIsPageableSearch,
  //   advancedSearchFormValues,
  //   setAdvancedSearchFormValues,
  //   setAccountListPage,
  //   isPageableSearch,
  //   setSearchByNameFields,
  //   advancedSearchForm,
  //   searchByNameForm,
  // } = props;
  // const { accountStatuses } = useSelector((state: RootStateOrAny) => state.dicts);
  // const isCollapseOpened = isPageableSearch ? 1 : 0;

  // const onFinish = (values) => {
  //   const parsedValues: FormFieldValue[] = [];

  //   Object.keys(values).forEach((key) => {
  //     if (values[key] !== "" && values[key] !== undefined) {
  //       parsedValues.push({ name: key, value: values[key] });
  //     }
  //   });

  //   setAdvancedSearchFormValues(parsedValues);
  //   setIsPageableSearch(true);
  //   setAccountListPage(1);
  //   if (isPageableSearch) {
  //     handlePageableSearch(parsedValues);
  //   }
  //   setSearchByNameFields(undefined);
  //   searchByNameForm.resetFields();
  // };

  const onReset = () => {
    advancedSearchForm.resetFields();
    setFilters((prev) => {
      return { ...initialStateFilters, size: prev.size };
    });
  };

  const onFinish = (attrs) => {
    console.log("onFinish", attrs);
    setFilters((prev) => {
      return { ...prev, page: initialStateFilters.page, ...attrs };
    });
  };
  // console.log('advancedSearchFormValues', advancedSearchFormValues);
  // console.log('dicCurrencies', dicCurrencies);

  return (
    <Collapse expandIconPosition="right" defaultActiveKey={0}>
      <Panel header="Расширенный поиск" key="1">
        <Form
          style={{ marginTop: 20 }}
          wrapperCol={{ span: 19 }}
          form={advancedSearchForm}
          onFinish={onFinish}
          onReset={onReset}
          labelAlign="left"
          initialValues={initialStateFilters}
        >
          <Row gutter={50} justify="center">
            <Col span={11}>
              <Form.Item
                name="offeringId"
                label="Продукт"
                labelCol={{ span: 6 }}
                rules={[{ required: true, message: "Необходимо выбрать продукт" }]}
              >
                <Select allowClear placeholder="Введите продукт" mode="multiple">
                  {Array.isArray(offerList) &&
                    offerList.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.name}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={11}>
              <Form.Item name="destinationName" label="Направление" labelCol={{ span: 7 }}>
                <Input allowClear placeholder="Введите направление" />
              </Form.Item>
              <Form.Item
                name="currencyId"
                label="Валюта отображения"
                labelCol={{ span: 7 }}
                rules={[{ required: true, message: "Необходимо выбрать валюту" }]}
              >
                <Select allowClear placeholder="Выберите валюту">
                  {dicCurrencies?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Space>
              <Form.Item>
                <Button htmlType="reset">Сброс параметров</Button>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Применить
                </Button>
              </Form.Item>
            </Space>
          </Row>
        </Form>
      </Panel>
    </Collapse>
  );
}
